import { render, staticRenderFns } from "./user.vue?vue&type=template&id=400ac7c1&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=400ac7c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ac7c1",
  null
  
)

export default component.exports